import {FormattedMessage} from "react-intl";
import React from "react";

export const faqCardsBody = (index) => {
    switch (index){
        case 1:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_1.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_1.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_1.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_1.body.paragraph_4"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_1.body.paragraph_5"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 2:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_2.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_2.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_2.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_2.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_2.body.list_item_3"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_2.body.list_item_4"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_2.body.list_item_5"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_2.body.list_item_6"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_2.body.list_item_7"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_2.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_2.body.paragraph_4"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 3:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_3.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_3.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_3.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_3.body.list_item_3"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_3.body.list_item_4"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_3.body.list_item_5"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_3.body.list_item_6"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_3.body.list_item_7"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_3.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_3.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 4:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_4.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_4.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_4.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_4.body.list_item_3"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_4.body.list_item_4"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_4.body.list_item_5"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_4.body.list_item_6"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_4.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 5:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_5.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_5.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_5.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_5.body.list_item_3"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_5.body.list_item_4"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_5.body.list_item_5"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_5.body.list_item_6"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_5.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 6:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_6.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_6.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_6.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_6.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_6.body.list_item_3"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_6.body.list_item_4"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_6.body.list_item_5"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_6.body.list_item_6"
                                defaultMessage="" />
                        </li>
                    </ul>
                </div>
            )
        case 7:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_7.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_7.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_7.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_7.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_7.body.list_item_3"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_7.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                </div>
            )
        case 8:
            return (
                <div>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_8.body.paragraph_1"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_8.body.paragraph_2"
                            defaultMessage="" />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_8.body.list_item_1"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_8.body.list_item_2"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_8.body.list_item_3"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_8.body.list_item_4"
                                defaultMessage="" />
                        </li>
                        <li>
                            <FormattedMessage
                                id="faq.jobs.questions.question_8.body.list_item_5"
                                defaultMessage="" />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_8.body.paragraph_3"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_8.body.paragraph_4"
                            defaultMessage="" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="faq.jobs.questions.question_8.body.paragraph_5"
                            defaultMessage="" />
                    </p>
                </div>
            )

        default:
            return (<></>)
    }
}

export const faqCardsHeader = (index) => {
    switch (index){
        case 1:
            return (<FormattedMessage
                id="faq.jobs.questions.question_1.title"
                defaultMessage="Comment trouver un métier dans le digital qui vous convienne ?" />)
        case 2:
            return (<FormattedMessage
                id="faq.jobs.questions.question_2.title"
                defaultMessage="Quels sont les métiers du digital qui recrutent actuellement et quels sont les postes les plus demandés ?" />)
        case 3:
            return (<FormattedMessage
                id="faq.jobs.questions.question_3.title"
                defaultMessage="Quels sont les débouchés dans le secteur du marketing et de la communication digitale ?" />)
        case 4:
            return (<FormattedMessage
                id="faq.jobs.questions.question_4.title"
                defaultMessage="Quels métiers propose Urban Linker ?" />)
        case 5:
            return (<FormattedMessage
                id="faq.jobs.questions.question_5.title"
                defaultMessage="Quels sont les profils et compétences tendances pour les métiers tech ?" />)
        case 6:
            return (<FormattedMessage
                id="faq.jobs.questions.question_6.title"
                defaultMessage="Quels sont les profils et compétences tendances pour les métiers du marketing digital ?" />)
        case 7:
            return (<FormattedMessage
                id="faq.jobs.questions.question_7.title"
                defaultMessage="Quelle est l’approche d’ Urban Linker pour  ma recherche d’emploi ?" />)
        case 8:
            return (<FormattedMessage
                id="faq.jobs.questions.question_8.title"
                defaultMessage="Les conseils d’Urban Linker" />)

        default:
            return (<FormattedMessage
                id="faq.jobs.title"
                defaultMessage="Nous répondons à vos questions" />)
    }
}
